module.exports = __webpack_public_path__ + "img/2024_0.22b9374e.webp";